import { createListingStepMachine } from '../../step-machine/listingStep.machine';
import { API_CALLS } from './api';
import { AdditionalTermsFormValues } from './types';

export const msaasAdditionalTermsMachine = createListingStepMachine<AdditionalTermsFormValues>(
  API_CALLS.patchMsaas,
  'msaasListingsState'
);

export const jobListingAdditionalTermsMachine = createListingStepMachine<AdditionalTermsFormValues>(
  API_CALLS.patchJob,
  'jobListingState'
);
